export function redirectToOtherQuestionSet(
  questionSet,
  applicationGuid?: string
) {
  // Handle edge case for IE so everything doesn't just break
  if (typeof URL !== 'function') {
    return
  }

  const baseUrl = window.location.href
  const urlObject = new URL(baseUrl)

  // Drop sensitive params before updating the question set to prevent propagation
  const sensitiveParams = ['ssn', 'coBorrowerSsn', 'co-borrower-ssn']
  sensitiveParams.forEach((key) => urlObject?.searchParams?.delete(key))

  urlObject?.searchParams?.set('question-set', questionSet)
  if (applicationGuid) {
    urlObject?.searchParams?.set('application-guid', applicationGuid)
  }

  const newUrl = urlObject.href

  if (baseUrl !== newUrl) {
    window.location.href = newUrl
  }
}
